/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Earth_Day_2025_Impact_Water_DescriptionInputs */

const en_earth_day_2025_impact_water_description = /** @type {(inputs: Earth_Day_2025_Impact_Water_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`That’s about 
1 month's supply for ${i?.number} people.`)
};

const ar_earth_day_2025_impact_water_description = /** @type {(inputs: Earth_Day_2025_Impact_Water_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`هذا يعادل 
مخزون شهر واحد ل ${i?.number} شخص.`)
};

const de_earth_day_2025_impact_water_description = /** @type {(inputs: Earth_Day_2025_Impact_Water_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Das ist ungefähr 
1 Monatsvorrat für ${i?.number} Person.`)
};

const es_earth_day_2025_impact_water_description = /** @type {(inputs: Earth_Day_2025_Impact_Water_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eso es aproximadamente 
1 mes de suministro para ${i?.number} persona/s.`)
};

const fr_earth_day_2025_impact_water_description = /** @type {(inputs: Earth_Day_2025_Impact_Water_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cela correspond approximativement à la consommation mensuelle d'une personne.`)
};

const it_earth_day_2025_impact_water_description = /** @type {(inputs: Earth_Day_2025_Impact_Water_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reppresenta circa 
1 mese di scorta per ${i?.number} persona.`)
};

const ja_earth_day_2025_impact_water_description = /** @type {(inputs: Earth_Day_2025_Impact_Water_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`約1か月間で${i?.number}人が
使用する分に相当します`)
};

const ko_earth_day_2025_impact_water_description = /** @type {(inputs: Earth_Day_2025_Impact_Water_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`이는 약 ${i?.number}명의
월 소비량과 같아요.`)
};

const pt_br_earth_day_2025_impact_water_description = /** @type {(inputs: Earth_Day_2025_Impact_Water_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Equivale a
1 mês de abastecimento para ${i?.number} pessoas.`)
};

const ru_earth_day_2025_impact_water_description = /** @type {(inputs: Earth_Day_2025_Impact_Water_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Это примерно 
месячный запас для ${i?.number} человека.`)
};

const th_earth_day_2025_impact_water_description = /** @type {(inputs: Earth_Day_2025_Impact_Water_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`นั่นคือปริมาณน้ำที่เพียงพอ
สำหรับ ${i?.number} คนใน 1 เดือน`)
};

const tr_earth_day_2025_impact_water_description = /** @type {(inputs: Earth_Day_2025_Impact_Water_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bu, yaklaşık 
${i?.number} kişi için 1 aylık tedariktir.`)
};

const zh_cn_earth_day_2025_impact_water_description = /** @type {(inputs: Earth_Day_2025_Impact_Water_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`相当于
${i?.number} 个人 1 个月的用水量`)
};

const zh_tw_earth_day_2025_impact_water_description = /** @type {(inputs: Earth_Day_2025_Impact_Water_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`相當於
${i?.number} 個人 1 個月的用水量`)
};

/**
* | output |
* | --- |
* | "That’s about 1 month's supply for {number} people." |
*
* @param {Earth_Day_2025_Impact_Water_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const earth_day_2025_impact_water_description = /** @type {((inputs: Earth_Day_2025_Impact_Water_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earth_Day_2025_Impact_Water_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earth_day_2025_impact_water_description(inputs)
	if (locale === "ar") return ar_earth_day_2025_impact_water_description(inputs)
	if (locale === "de") return de_earth_day_2025_impact_water_description(inputs)
	if (locale === "es") return es_earth_day_2025_impact_water_description(inputs)
	if (locale === "fr") return fr_earth_day_2025_impact_water_description(inputs)
	if (locale === "it") return it_earth_day_2025_impact_water_description(inputs)
	if (locale === "ja") return ja_earth_day_2025_impact_water_description(inputs)
	if (locale === "ko") return ko_earth_day_2025_impact_water_description(inputs)
	if (locale === "pt_br") return pt_br_earth_day_2025_impact_water_description(inputs)
	if (locale === "ru") return ru_earth_day_2025_impact_water_description(inputs)
	if (locale === "th") return th_earth_day_2025_impact_water_description(inputs)
	if (locale === "tr") return tr_earth_day_2025_impact_water_description(inputs)
	if (locale === "zh_cn") return zh_cn_earth_day_2025_impact_water_description(inputs)
	return zh_tw_earth_day_2025_impact_water_description(inputs)
});